import '.bh{position:fixed;}.ssr-plugin'
import '.ah{padding:16px;}.ssr-plugin'
import '.e1{z-index:1;}.ssr-plugin'
import '.dr{right:0px;}.ssr-plugin'
import '.b{height:100vh;}.ssr-plugin'
import { Card } from '../Cms/Card.js'
import { styled } from 'inlines'
import { colors } from '../../tokens/colors.js'
import { ReferenceValue } from './index.js'
import { IconButton } from '../IconButton/index.js'
import { Table } from '../Table/index.js'
import { Text } from '../Text/index.js'
import { Separator } from '../Separator/index.js'
import { radius } from '../../utils/radius.js'
import { AppHeader } from '../AppHeader/index.js'
import { Stack } from '../Stack/index.js'

type ExpandedViewProps = {
  setExpandedView: (x: boolean) => void
  topOffset?: number
  leftOffset?: number
  value?: ReferenceValue | ReferenceValue[]
  type?: string
  schema?: any
}

export const ExpandedView = ({
  setExpandedView,
  topOffset = 62,
  leftOffset = 276,
  value,
  type,
  schema,
}: ExpandedViewProps) => {
  const valueArray = Array.isArray(value) ? value : value ? [value] : []

  return (
    <div className="bh ah e1 dr b"
      style={{
        top: topOffset,
        left: leftOffset,
        background: `linear-gradient(${colors.black5}),
          linear-gradient(${colors.neutralInverted100})`,
      }}
    >
      <Card
        style={{
          height: '100%',
          margin: 0,
          // height: `calc(100% - ${topOffset + 32}px)`,
        }}
      >
        <AppHeader variant="sub">
          <AppHeader.Left>
            <IconButton
              icon="arrow-left"
              keyHint="Esc"
              tooltip="Back"
              onClick={() => setExpandedView(false)}
            />
            <Stack fitContent style={{ marginLeft: 6 }}>
              <Text
                selectableText={false}
                variant="subheading-medium"
                color="neutral80"
                singleLine
                style={{ textTransform: 'capitalize' }}
              >
                {type}
              </Text>
            </Stack>
          </AppHeader.Left>
        </AppHeader>
        <Stack
          style={{
            animation: '300ms tilt-soft cubic-bezier(0.30,-0.00,0.60,1.10)',
            background: `linear-gradient(${colors.white5}),
              linear-gradient(${colors.neutralInverted100})`,
            boxShadow: `0px 8px 12px ${colors.black10}`,
            borderRadius: radius[20],
            border: `1px solid &{colors.neutral10}`,
            height: '100%',
            width: '100%',
          }}
        >
          <Table
            data={valueArray as any}
            schemaType={type}
            schema={schema}
            selectedRows={null}
            colVisibility="scroll"
          />
        </Stack>
      </Card>
    </div>
  )
}
